import { Invalid, Valid } from "#root/utility/validators";

import { useFieldSet } from "./fieldset";

export function Validity() {
  const field = useFieldSet()?.field;

  if (field?.validity === Invalid) {
    return <p className="text-sm text-red-500 mt-1 mb-0">{field.hint || "Invalid"}</p>;
  }

  if (field?.validity === Valid) {
    return <p className="text-sm text-green-600 mt-1 mb-0">{field.hint || "Valid"}</p>;
  }

  return <p className="text-sm text-[#999] mt-1 mb-0">{field?.hint || "\u00a0"}</p>;
}
